import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "holder", "errors", "format", "capacity", "productFields", "mediaFields", "content", "layout", "selection", "product", "layouts", "counter"]
  static values = { url: String }

  connect() {
    this.revision = (this.revision || 0) + 1
    this.previousFormat = this.hasFormatTarget ? this.formatTarget.value : null
    this.schedule()
  }

  disconnect() {
    clearTimeout(this.timer)
    this.revision++
  }

  schedule() {
    this.updateFields()
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.refresh(), 200)
  }

  preset(event) {
    this.capacityTarget.value = event.currentTarget.dataset.capacity
    this.formatTarget.value = "grid"
    this.schedule()
  }

  orientation(event) {
    const portrait = event.currentTarget.dataset.orientation === "portrait"
    this.frameTarget.style.width = portrait ? "31.64%" : "100%"
    this.frameTarget.style.aspectRatio = portrait ? "9/16" : "16/9"
  }

  updateFields() {
    if (this.hasFormatTarget) {
      const media = this.formatTarget.value === "media"
      this.productFieldsTarget.classList.toggle("hidden", media)
      this.mediaFieldsTarget.classList.toggle("hidden", !media)
      if (this.previousFormat !== this.formatTarget.value && this.formatTarget.value === "list") this.capacityTarget.value = 10
      this.previousFormat = this.formatTarget.value
    }
    if (!this.hasSelectionTarget) return
    const enabled = !!this.layoutTarget.value
    const tableId = this.contentTarget.value
    const layout = JSON.parse(this.layoutsTarget.textContent).find((candidate) => String(candidate.id) === this.layoutTarget.value)
    this.productTargets.forEach((input) => {
      const belongs = input.closest("label").dataset.tableId === tableId
      input.closest("label").classList.toggle("hidden", !belongs)
      input.disabled = !enabled || !belongs
      if (!belongs || !enabled) input.checked = false
    })
    const count = this.productTargets.filter((input) => input.checked && !input.disabled).length
    this.counterTarget.textContent = enabled ? this.element.dataset.selectionCount.replace("%{count}", count).replace("%{capacity}", layout ? layout.capacity : 0) : this.element.dataset.selectionHint
    this.counterTarget.classList.toggle("text-danger", !!layout && count > layout.capacity)
    // The server enforces capacity. Leave choices enabled so users can replace
    // a selection without an awkward uncheck-first interaction.
  }

  async refresh() {
    this.updateFields()
    const revision = ++this.revision
    const token = document.querySelector('meta[name="csrf-token"]')
    try {
      const response = await fetch(this.urlValue, { method: "POST", body: new FormData(this.element), headers: { "X-CSRF-Token": token ? token.content : "", "Accept": "application/json" } })
      const payload = await response.json()
      if (revision !== this.revision) return
      if (!response.ok) {
        this.errorsTarget.textContent = (payload.errors || [this.element.dataset.previewError]).join(" · ")
        this.frameTarget.contentWindow.postMessage({ type: "composition-preview", payload: { item: null, assets: [] } }, location.origin)
        return
      }
      this.errorsTarget.textContent = ""
      this.frameTarget.contentWindow.postMessage({ type: "composition-preview", payload }, location.origin)
    } catch (_) {
      if (revision === this.revision) this.errorsTarget.textContent = this.element.dataset.previewError
    }
  }
}
